<template>
  <el-row>
    <el-col v-if="employees.length > 1" :span="24" :offset="0">
      <div class="flex justify-space-between mb-5">
        <div class="box" style="display: flex; position: relative; float: left">
          <el-select
            v-model="employee"
            placeholder="Responsable"
            size="mini"
            filterable
            clearable
          >
            <el-option
              v-for="item in employees"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="optionSelected"
            placeholder="Objetivos"
            size="mini"
            filterable
            @change="handleChangeCmiORgantt"
          >
            <el-option
              v-for="item in optionObjectives"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="box">
          <el-button
            round
            size="mini"
            style="padding-left: 20px; padding-rigth: 20px"
            type="primary"
            @click="loadButton"
            >Refrescar</el-button
          >
        </div>
      </div>
    </el-col>
    <!-- <el-col>
      <div class="flex justify-space-between mb-5">
        <div class="box">
          <DepartmentSelector
            @selection-change="handleChangeDepartment"
            @onDirectionChange="handleChangeDirection"
            :onlyDepartment="false"
          />
        </div>
      </div>
    </el-col> -->

    <el-col>
      <el-row>
        <TaskCard
          :employee="employee"
          :refresh-stat="refreshStats"
          :employeesSelected="employees"
          :optionSelected="optionSelected"
        />
      </el-row>
    </el-col>

    <el-col
      v-if="IsInRoles([roles.EjecutivoDeVentas, roles.CEO, roles.SuperUsuario])"
    >
      <el-row class="mt-20">
        <SalesStat :employee="employee" :refresh-stat="refreshStats" />
      </el-row>
    </el-col>

    <el-col
      v-if="IsInRoles([roles.SoporteVentas, roles.CEO, roles.SuperUsuario])"
    >
      <el-row class="mt-20">
        <SalesSupportStat :employee="employee" :refresh-stat="refreshStats" />
        <!--
        <DealReportBySellers/>
        -->
      </el-row>
    </el-col>

    <el-col
      v-if="
        IsInRoles([
          roles.ServicioAlCliente,
          roles.CoornidadorDeServicioAlCliente,
          roles.CEO,
          roles.SuperUsuario,
          roles.Finanzas
        ])
      "
    >
      <el-row class="mt-20">
        <CustomerServiceStat
          :employee="employee"
          :employees="employees"
          :refresh-stat="refreshStats"
        />
      </el-row>
    </el-col>

    <el-col
      v-if="
        IsInRoles([
          roles.CEO,
          roles.SuperUsuario,
          roles.CuentasPorCobrar,
          roles.Finanzas
        ])
      "
    >
      <el-row class="mt-20">
        <EquipmentStat :employee="employee" :refresh-stat="refreshStats" />
      </el-row>
    </el-col>
    <el-col
      v-if="
        IsInRoles([
          roles.CEO,
          roles.SuperUsuario,
          roles.CuentasPorCobrar,
          roles.Finanzas
        ])
      "
    >
      <el-row class="mt-20">
        <ChargesStat :employee="employee" :refresh-stat="refreshStats" />
      </el-row>
    </el-col>

    <el-col>
      <el-row class="mt-20">
        <InvoicesOrPayments
          :refresh-stat="refreshStats"
          v-if="
            IsInRoles([
              roles.CEO,
              roles.SuperUsuario,
              roles.CuentasPorCobrar,
              roles.Finanzas
            ]) ||
            this.currentUser.PositionID == 34 ||
            this.currentUser.PositionID == 117 ||
            this.currentUser.PositionID == 79 ||
            this.currentUser.EmployeeId == 37
          "
        />
      </el-row>
    </el-col>

    <el-col>
      <el-row class="mt-20">
        <Birthdays :employee="employee" :refresh-stat="refreshStats" />
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import CustomerServiceStat from "@/components/activity_flow/CustomerServiceStat.vue";
import TaskCard from "@/components/activity_flow/Cmi/TaskStatusCard.vue";
import SalesStat from "@/components/activity_flow/SalesStat.vue";
import ChargesStat from "@/components/activity_flow/ChargesStat.vue";
import EquipmentStat from "@/components/activity_flow/EquipmentStat.vue";
import SalesSupportStat from "@/components/activity_flow/SalesSupportStat.vue";
//import DealReportBySellers from "@/views/modules/sales/reports/DealReportBySellers.vue";
import Birthdays from "@/components/activity_flow/birthdays/Birthdays.vue";
import InvoicesOrPayments from "@/components/activity_flow/InvoicesOrPayments.vue";
// import DepartmentSelector from "@/components/Company/DepartmentSelector.vue";

import { formatArrayToElSelect } from "@/utils";

export default {
  name: "ListCardStats",
  components: {
    TaskCard,
    SalesStat,
    CustomerServiceStat,
    EquipmentStat,
    ChargesStat,
    SalesSupportStat,
    //DealReportBySellers,
    Birthdays,
    InvoicesOrPayments
    // DepartmentSelector
  },
  async created() {
    this.employee = this.currentUser.EmployeeId;
    await this.loadEmployees();
  },
  data() {
    return {
      employee: 0,
      employees: [],
      optionObjectives: [
        { value: 0, label: "CMI" },
        { value: 1, label: "Gantt" }
      ],
      optionSelected: 1,
      refreshStats: false,
      directionId: null,
      departmentId: null
    };
  },
  computed: {
    updateCompany() {
      return this.$store.state.updateCompany;
    }
  },
  methods: {
    reloadProductivy() {
      let params = {
        timeout: 3 * 60 * 1000,
        EmployeeId: this.currentUser.EmployeeId,
        CompanySelected: this.currentUser.CompanySelected
      };

      const date = new Date();
      if (this.$store.state.productivity.chosenUser >= 0) {
        params.EmployeeId = this.$store.state.productivity.chosenUser;
      }
      this.$store.dispatch("productivity/GetTaksAll", params);
      params.Month = date.getMonth();
      this.$store.dispatch("productivity/GetTaks", params);
    },
    formatArrayToElSelect,
    async loadEmployees() {
      let params = {
        Employeeid: this.currentUser.EmployeeId,
        CompanySelected: this.currentCompany
      };
      const { data } = await this.$http.get(
        "/api/CMI/Objetives/GetUsersObjetivos",
        {
          timeout: 3 * 60 * 1000,
          params
        }
      );
      this.employees = this.formatArrayToElSelect(data, {
        value: "EmployeeID",
        label: "Name"
      });
    },
    loadButton() {
      this.refreshStats = !this.refreshStats;
      this.reloadProductivy();
      console.log("current", this.currentUser);
    },
    async chosenUserGetProductivityAsync(
      employeeId,
      companySelected,
      optionSelected
    ) {
      // Super User can choose an user and see their stats
      const params = {
        EmployeeId: employeeId,
        CompanySelected: companySelected,
        Option: optionSelected
      };
      this.$store.dispatch("productivity/GetProductivityByPersonAsync", params);
    }, //GetProductivityByDeparmentAsync
    async chosenUserGetProductivityAsyncDepartment(
      employeeId,
      companySelected
    ) {
      // Super User can choose an user and see their stats
      const params = {
        EmployeeId: employeeId,
        CompanySelected: companySelected
      };
      this.$store.dispatch(
        "productivity/GetProductivityByDeparmentAsync",
        params
      );
    },
    handleChangeCmiORgantt() {
      // let param = {
      //   selectOption: this.optionSelected,
      //   employeeId: this.employee
      // };
      this.chosenUserGetProductivityAsync(
        this.employee,
        this.companySelected,
        this.optionSelected
      );
      this.$emit("change-CmiORgantt", this.optionSelected);
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.departmentId = null;
    },
    handleChangeDepartment(DepartmentID) {
      this.departmentId = DepartmentID;
    }
  },
  watch: {
    updateCompany() {
      this.loadButton();
    },
    employee: async function (newEmployee) {
      this.$store.dispatch("productivity/SetChosenUser", newEmployee);
      this.chosenUserGetProductivityAsync(
        newEmployee,
        this.companySelected,
        this.optionSelected
      );
      this.chosenUserGetProductivityAsyncDepartment(
        newEmployee,
        this.companySelected
      );
      this.handleChangeCmiORgantt();

      // let params = {
      //   EmployeeId: newEmployee,
      //   CompanySelected: this.companySelected
      // };

      // this.$store.dispatch("productivity/GetInteralRequest", params);
    }
  }
};
</script>

<style></style>
